var map = {
	"./bg-footer-cta-comer.svg": 63,
	"./bg-footer-cta.svg": 64,
	"./bg-header-comer.svg": 65,
	"./bg-header.svg": 66,
	"./flag-de.svg": 67,
	"./flag-en.svg": 68,
	"./flag-fr.svg": 69,
	"./flag-it.svg": 70,
	"./ic-alert-circle.svg": 71,
	"./ic-angle-down.svg": 72,
	"./ic-arrow-left.svg": 73,
	"./ic-arrow-right.svg": 74,
	"./ic-asterisk.svg": 75,
	"./ic-checked-circle.svg": 76,
	"./ic-cross-circle.svg": 77,
	"./ic-cross.svg": 78,
	"./ic-download.svg": 79,
	"./ic-envelope-circle.svg": 80,
	"./ic-home-circle.svg": 81,
	"./ic-linkedin-circle.svg": 82,
	"./ic-magnifier.svg": 83,
	"./ic-menu-circle.svg": 84,
	"./ic-message-circle.svg": 85,
	"./ic-overview-circle.svg": 86,
	"./ic-phone-24-circle.svg": 87,
	"./ic-phone-circle.svg": 88,
	"./ic-plus.svg": 89,
	"./ic-quote.svg": 90,
	"./ic-suppliers-circle.svg": 91,
	"./ic-xing-circle.svg": 92,
	"./logo-eurodrives.svg": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;